<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <table-custom
      :board="board"
      :is-print="isPrint"
      title="보유기계기구 정보"
      :custom-add-handler="true"
      @add-row="addRow"
      :tableData="[
        {
          id: 'cell1',
          title: '기계기구 사진',
          type: 'customType',
          selectData: [],
          placeholder: '선택',
        },
        { id: 'cell2', title: '기계종류', type: 'text', placeholder: '내용' },
        { id: 'cell3', title: '기계명', type: 'text', placeholder: '내용' },
        { id: 'cell4', title: '등록(인증)번호', type: 'text', placeholder: '내용' },
        { id: 'cell5', title: '검사종류', type: 'text', placeholder: '내용' },
        { id: 'cell6', title: '검사만료일', type: 'text', placeholder: '내용' },
        { id: 'cell7', title: '보험만료일', type: 'text', placeholder: '내용' },
        { id: 'cell8', title: '운전원', type: 'text', placeholder: '내용' },
        { id: 'cell9', title: '수행작업', type: 'text', placeholder: '내용' },
      ]"
      v-model="form.checkList"
    >
      <template #customType="{ trData, value, input }">
        <!-- input 이 undefined 되는 이유를 찾아야 함 -->
        <!-- 부모 / 자식 노드에서 높이지정하는 값이 없어서 우선 300px 고정함 -->
        <FileUploaderTransparent v-if="input" :value="value" @input="input" class="w-full" :readonly="board.readonly || isPrint" style=" height:150px !important;background-size: contain; background-repeat: no-repeat;" />
        <FileUploaderTransparent v-else :value="value" class="w-full" :readonly="board.readonly || isPrint" style="background-size: contain; background-repeat: no-repeat" />

      </template>
    </table-custom>

    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" class="mt-28px" />
  </div>
</template>

<script>
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import SearchNavStartEnd from "../../../../components/nav/SearchNavStartEnd.vue";
import FileUploadModule from "../../../modules/FileUploadModule.vue";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TimeSelector from "@/components/selector/TimeSelector.vue";
import TableCustom from "@/components/TableCustom.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
import PopupLoadPrevBoard from "@/popup/PopupLoadPrevBoard.vue";
import FileUploaderTransparent from "@/components/FileUploaderTransparent.vue";

export default {
  components: {
    FileUploaderTransparent,
    PopupLoadPrevBoard,
    PhotoUploadGridModule,
    TableCustom,
    TimeSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    SearchNavStartEnd,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        checkList: [],
        fileList: [],
      },
    };
  },
  methods: {
    addRow(id) {
      this.form.checkList.push({
        id: id,
        cell1: {},
        cell2: "",
        cell3: "",
        cell4: "",
      });
    },

  },
};
</script>
